<div class="status-pill" data-testid="estado-asociacion">
    <span class="text-muted">Estado:</span>
    <span class="badge" data-testid="estado-etiqueta" [ngClass]="estado === 'activa' ? 'bg-success' : estado === 'desactivada' ? 'bg-danger' : 'bg-secondary'">
        <i class="bi me-1" [ngClass]="estado === 'activa' ? 'bi-check-circle-fill' : estado === 'desactivada' ? 'bi-slash-circle-fill' : 'bi-question-circle-fill'" aria-hidden="true"></i>{{ etiqueta }}
    </span>
</div>
